import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';

interface ScanDetailsInputsProps {
  scanDate: string;
  scanType: string;
  uploadType: string;
  scanNumber: string;
  scanArea: string;
  onScanDateChange: (value: string) => void;
  onScanTypeChange: (value: string) => void;
  onUploadTypeChange: (value: string) => void;
  onScanNumberChange: (value: string) => void;
  onScanAreaChange: (value: string) => void;
}

export const ScanDetailsInputs: React.FC<ScanDetailsInputsProps> = ({
  scanDate,
  scanType,
  uploadType,
  scanNumber,
  scanArea,
  onScanDateChange,
  onScanTypeChange,
  onUploadTypeChange,
  onScanNumberChange,
  onScanAreaChange,
}) => {
  return (
    <>
      {/* Scan Date */}
      <div className="space-y-2">
        <Label htmlFor="scan_date">Scan Date</Label>
        <Input
          id="scan_date"
          type="date"
          value={scanDate}
          onChange={(e) => onScanDateChange(e.target.value)}
          required
        />
      </div>

      {/* Scan Type */}
      <div className="space-y-2">
        <Label htmlFor="scan_type">Scan Type</Label>
        <Select value={scanType} onValueChange={onScanTypeChange}>
          <SelectTrigger id="scan_type">
            <SelectValue placeholder="Select scan type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Progress">Progress</SelectItem>
            <SelectItem value="Asbuild">Asbuild</SelectItem>
            <SelectItem value="Corridor">Corridor</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Upload Type */}
      <div className="space-y-2">
        <Label htmlFor="upload_type">Upload Type</Label>
        <Select value={uploadType} onValueChange={onUploadTypeChange}>
          <SelectTrigger id="upload_type">
            <SelectValue placeholder="Select upload type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Full">Full</SelectItem>
            <SelectItem value="Partial">Partial</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Scan Number */}
      <div className="space-y-2">
        <Label htmlFor="scan_number">Scan Number</Label>
        <Input
          id="scan_number"
          type="number"
          value={scanNumber}
          onChange={(e) => onScanNumberChange(e.target.value)}
          required
        />
      </div>

      {/* Scan Area */}
      <div className="space-y-2">
        <Label htmlFor="scan_area">Scan Area</Label>
        <Input
          id="scan_area"
          type="text"
          value={scanArea}
          onChange={(e) => onScanAreaChange(e.target.value)}
          placeholder="Enter scan area"
          required
        />
      </div>
    </>
  );
};

